module.exports = __webpack_public_path__ + "static/media/react-hero-logo.9394d800.svg";